import { REQUEST_URL } from "../app/constants";
import { RequestUtil } from "../utils";

export const DeviceService = {
  getDevices: () => {
    const url = REQUEST_URL.DEVICES;
    return RequestUtil.get({ url });
  },

  updateDevice: (deviceId: string, data: Record<string, unknown>) => {
    const url = `${REQUEST_URL.DEVICES}/${deviceId}`;
    return RequestUtil.put({ url, data });
  },

  triggerDeviceSync: (deviceId: string) => {
    const url = REQUEST_URL.DEVICE_SYNC.replace("{deviceId}", deviceId);
    return RequestUtil.post({ url, data: {} });
  },

  setCredentials: (deviceId: string, data: { username: string; password: string }) => {
    const url = REQUEST_URL.DEVICE_CREDENTIALS.replace("{deviceId}", deviceId);
    return RequestUtil.put({ url, data });
  },

  regenerateRecoveryCode: (deviceId: string) => {
    const url = REQUEST_URL.DEVICE_RECOVERY_CODE.replace("{deviceId}", deviceId);
    return RequestUtil.post({ url, data: {} });
  },

  revokeCredentials: (deviceId: string) => {
    const url = REQUEST_URL.DEVICE_CREDENTIALS.replace("{deviceId}", deviceId);
    return RequestUtil.delete({ url });
  },
};
